import { HTMLAttributes } from 'react';

export interface ImageViewerProps {
  closable?: boolean;
  visible?: boolean;
  onDismiss?: () => void;
  images: string[];
  selectedImageIndex: number;
}

export type ImageViewerComponentProps = HTMLAttributes<HTMLDivElement> & ImageViewerProps;
